import { render, staticRenderFns } from "./ResetView.vue?vue&type=template&id=3c6da306&"
import script from "./ResetView.vue?vue&type=script&lang=js&"
export * from "./ResetView.vue?vue&type=script&lang=js&"
import style0 from "./ResetView.vue?vue&type=style&index=0&id=3c6da306&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VExpandTransition,VIcon})
